import Padlock from '@/assets/padlock.svg?react';
import cn from '@/utils/cn';

import BankInfoInputs from './BankInfoInputs';
import { useLingui } from '@lingui/react';

const BankInfo = () => {
  const { i18n } = useLingui();

  return (
    <section
      className={cn(
        'w-full max-w-full space-y-4 rounded-[10px] bg-gray-200 px-3.5 py-4 md:space-y-5 md:rounded-lg md:p-6'
      )}
    >
      <div className="grid grid-cols-1 gap-3 md:grid-cols-4">
        <p className="h5 flex items-center gap-2 md:col-span-4">
          <Padlock className="size-4 flex-none text-blue-600" />
          {i18n.t(
            'Podaj numer rachunku bankowego, na który mamy przelać środki'
          )}
        </p>
        <BankInfoInputs />
      </div>
    </section>
  );
};

export default BankInfo;
